export const appLayoutDimensions = {
  headerHeight: 64,
  drawerWidth: 300,
  drawerCollapsedWidth: 72,
  cartSidebarWidth: 480,
} as const;
